import { ChevronLeft } from '@patrianna-icons/material-icons'
import cx from 'classnames'
import Link from 'next/link'
import type { CSSProperties, ReactNode } from 'react'

import classes from './styles.module.scss'

type Props = {
  href: string
  className?: string
  color?: 'white' | 'black'
  children?: ReactNode
  onClick?: () => void
  style?: CSSProperties
}

export default function BackButtonLink({ href, className, color = 'black', children, onClick, style }: Props) {
  return (
    <Link
      href={href}
      className={cx(className, classes.root, classes[color])}
      data-test='modal-back-button'
      onClick={onClick}
      prefetch={false}
      style={style}
    >
      <ChevronLeft className={classes.icon} />

      {children}
    </Link>
  )
}
